module.exports = __webpack_public_path__ + "img/DISE-logo.6c32f7bc.svg";